export const SECONDS_TO_MILLISECONDS_MULTIPLIER = 1000;
